module.exports = __webpack_public_path__ + "img/api.e745ed9c.svg";